var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-page",
    {
      attrs: {
        "is-showing-bandana": false,
        "is-showing-sitewide-modal": false,
      },
    },
    [
      _c(
        "template",
        { slot: "header" },
        [
          _vm._t("page-header", function () {
            return [_c("wa-page-header-simple", { key: "header" })]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "content" },
        [
          _vm._t("page-content", function () {
            return [
              _c(
                "main",
                {
                  staticClass: "app-content padding-y-7xl",
                  attrs: { role: "main" },
                },
                [
                  _c("div", { staticClass: "container" }, [
                    _c(
                      "div",
                      { staticClass: "laptop:margin-x-6xl" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "display-flex flex-column tablet:flex-row",
                          },
                          [
                            _c(
                              "div",
                              {
                                class: `purchase-${_vm.type} margin-auto margin-bottom-2xl tablet:margin-right-0 tablet:margin-bottom-0`,
                              },
                              [
                                _vm._t("purchase-product"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "text-center" },
                                  [
                                    _c(
                                      "site-link",
                                      { attrs: { to: { name: "plans" } } },
                                      [_vm._v("See other Plans")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "purchase-form tablet:margin-right-4xl",
                                staticStyle: {
                                  "--hr-border-color": "var(--white)",
                                  "--hr-border-width": "var(--border-width-xs)",
                                },
                              },
                              [_vm._t("purchase-flow")],
                              2
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._t("purchase-support"),
                      ],
                      2
                    ),
                  ]),
                ]
              ),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("wa-page-footer-simple", {
        attrs: { slot: "footer" },
        slot: "footer",
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }